<template>
    <div>
        <div v-if="loading"><loader></loader></div>
        <b-row>
            <b-col sm="12">
                <b-row>
                    <b-col sm="4">
                        <b-form-group>
                            <label for="nombre"><b>Nombre</b></label>
                            <b-form-input
                                name="nombre"
                                type="text"
                                v-model="filtro.nombre">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group>
                            <label for="sinonimo"><b>Sinonimo</b></label>
                            <b-form-input
                                id="sinonimo"
                                name="sinonimo"
                                type="text"
                                v-model="filtro.sinonimos">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group>
                            <label for="fabricante"><b>Fabricante</b></label>
                            <b-form-input
                                id="fabricante"
                                name="fabricante"
                                type="text"
                                v-model="filtro.proveedorfabricante">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                        <b-form-group>
                            <label for="fecha"><b>Fecha</b></label>
                            <br>
                            <el-date-picker
                                v-model="filtro.confecha"
                                id="range_date"
                                name="range_date"
                                type="monthrange"
                                range-separator="To"
                                start-placeholder="Año y Mes inicial"
                                end-placeholder="Año y Mes Final">
                            </el-date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                    <b-form-group >
                        <label for="bases">Bases</label>
                        <br>
                        <el-select
                            v-model="filtro.base"
                            filterable
                            remote
                            no-data-text="No hay datos que coincidan"
                            no-match-text="No hay datos que coincidan"
                            @focus="getBasesFiltro()">
                            <el-option
                            v-for="item in bases.data"
                            :key="item.id"
                            :label="item.descripcion"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group>
                            <label for="areas">Areas</label>
                        <br>
                            <el-select
                                v-model="filtro.area"
                                filterable
                                remote
                                no-data-text="No hay datos que coincidan"
                                no-match-text="No hay datos que coincidan"
                                @focus="getAreasFiltro()">
                                <el-option
                                v-for="item in areas.data"
                                :key="item.id"
                                :label="item.descripcion"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="2">
                        <b-button variant="primary" @click.prevent="buscador(filtro)"><i class="fa fa-search fa-lg "></i> Buscar</b-button>
                    </b-col>
                    <b-col sm="2">
                        <b-button @click.prevent="limpiar()" ><i class="fa fa-eraser fa-lg"></i> Limpiar</b-button>
                    </b-col>
                </b-row>
                <br>
                <b-collapse visible>
                    <b-table
                        style="font-size:8pt;"
                        responsive
                        striped
                        hover
                        :items="productos.data"
                        :fields="columnas"
                        :tbody-tr-class="unClass">
                        <template  v-slot:cell(sgaData)="data">
                            <span  v-if="data.item.sga.length > 0">SI</span>
                            <span  v-else>NO</span>
                        </template>
                        <template  v-slot:cell(nfpaData)="data">
                            <span  v-if="data.item.nfpa != null">SI</span>
                            <span  v-else>NO</span>
                        </template>
                        <template  v-slot:cell(hmisData)="data">
                            <span  v-if="data.item.hmisData !='NO'">SI</span>
                            <span  v-else>NO</span>
                        </template>
                        <template  v-slot:cell(unData)="data">
                            <span  v-if="data.item.u_n != null">SI</span>
                            <span  v-else>NO</span>
                        </template>
                        <template  v-slot:cell(contratista)="data">
                                <b-form-checkbox
                                  :id="'contratista'+data.item.id"
                                  @change="asigna(data.item.id, 'contratista', data.item.contratista)"
                                  v-model="data.item.contratista"
                                  :name="'contratista'+data.item.id"
                                  value="1"
                                  unchecked-value="0"
                                >
                                </b-form-checkbox>
                        </template>
                    </b-table>
                    <el-pagination
                        class="float-right"
                        v-model="filtro.page"
                        @current-change="setPagePagination"
                        :current-page="filtro.page"
                        small
                        layout="total, prev, pager, next"
                        :total="productos.total">
                    </el-pagination>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import loader from "../../../containers/loader";

export default {
    name:'buscador-productos',
    components:{
        loader
    },
    data() {
        return {
            mostrar:false,
            columnas:[
                {key: 'nombre', label: 'Nombre', sortable: true, thStyle: {'min-width': '150px !important'}},
                {key: 'sinonimos', label: 'Sinónimos', sortable: true, thStyle: {'min-width': '150px !important'}},
                {key: 'sgaData', label: 'SGA', sortable: true, thStyle: {'min-width': '80px !important', width: '80px !important'}},
                {key: 'nfpaData', label: 'NFPA', sortable: true, thStyle: {'min-width': '80px !important', width: '80px !important'}},
                {key: 'hmisData', label: 'HMIS', sortable: true, thStyle: {'min-width': '80px !important', width: '80px !important'}},
                {key: 'unData', label: 'UN', sortable: true, thStyle: {'min-width': '80px !important', width: '80px !important'}},
                {key: 'proveedorfabricante', label: 'Fabricante', sortable: true, thStyle: {'min-width': '150px !important', width: '150px !important'}},
                {key: 'contratista', label: 'Contratista', sortable: true, thStyle: {'min-width': '20px !important', width: '20px !important'}},
            ],
            rangeYear: ['',''],
            status: '',
            loading: true
        }
    },
    async created() {
        this.loading = false;
    },
    mounted() {

    },
    methods: {
        async limpiar(){
            this.loading = true;
            this.mostrar = false;
            await this.resetFiltro();
            await this.vistaAdmin();
            this.loading = false;
        },
        async buscarEmpresa(query){
            if (query.length >= 3) {
                await this.getEmpresaFiltro(query)
            }
        },

        async cargarBases(){
            this.mostrar = true
            await this.getBasesFiltro()
            await this.getCamposPersonalizados()
        },

        /**
         * Metodo que se inicia si el usuario es un administrador
         */
        async vistaAdmin(){
            await this.getProductosContra()
        },

        unClass(item) {
            if (!item) return
            if (item.vacio === true) return 'table-danger'
        },

        buscador(buscar) {
            this.setFiltro(buscar)
            this.getProductosContra()
        },

        descargaAdjunto(adj){
            window.open(process.env.VUE_APP_API_URL + 'storage/files/' + adj.adjunto);
        },
        ...mapActions('productos_contra',[
            'getProductosContra',
            'getProductosContraEmpresa',
            'getEmpresaFiltro',
            'getBasesFiltro',
            'getAreasFiltro',
            'descargarAdjunto',
            'getCamposPersonalizados',
            'getProductoTarjeta',
            'setPagePagination',
            'guardaContratista'
        ]),

        ...mapMutations('productos_contra',[
            'setFiltro',
            'setFiltroBases',
            'setFiltroAreas',
            'limpiarProducto',
            'setPermisosAdmin',
            'setPermisosEmpresa',
            'resetFiltro'
        ]),
        ...mapActions('empresa',[
            'getDiligenciados'
        ]),
        async asigna( id, tipo, valor ) {
           
            var dataCompact = {
                id: id,
                tipo: tipo,
                valor: valor
            };
            this.loading = true;
            await this.guardaContratista( dataCompact );
            await this.getProductosContra();
            this.loading = false;
        }
    },
    computed: {
        ...mapState('productos_contra',[
            'productos',
            'filtro',
            'empresas',
            'selectedProduct',
            'bases',
            'areas',
            'campos',
            'esEmpresa',
        ]),
        ...mapGetters('productos_contra',[
            'getParams'
        ]),
        ...mapState("empresa", [
            "edicionUsuario"
        ])
    },
}
</script>
<style>
.el-input__inner{
    height: 32px;
}

.el-date-editor .el-range-separator{
    line-height: 25px;
    width: 10%;
}

.el-date-editor--monthrange.el-input, .el-date-editor--monthrange.el-input__inner{
    width: 100%
}


</style>
